import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {LimsMaterial} from '../types'

export const LimsMaterialsQueryKey = 'limsMaterials'

const limsMaterialsQueryOptions = (plantCode: string) => ({
  queryKey: [LimsMaterialsQueryKey, plantCode] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<LimsMaterial[]>(
      `/plants/${plantCode}/materials/lims/materials`,
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = LimsMaterial[]> = {
  plantCode: string
  options?: Omit<UseQueryOptions<LimsMaterial[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useLimsMaterials = <TReturn = LimsMaterial[]>({plantCode, options}: Params<TReturn>) =>
  useQuery<LimsMaterial[], AxiosError, TReturn>({
    ...limsMaterialsQueryOptions(plantCode),
    ...options
  })
